<template>
  <div class="high-scores">
    <h3>🏆 High Scores</h3>
    <ol v-if="scores.length">
      <li
        v-for="(score, index) in scores"
        :key="score.id ?? `${score.name}-${score.points}-${index}`"
      >
        <span>{{ score.name }}</span>
        <span>{{ Number(score.points).toLocaleString() }}</span>
      </li>
    </ol>
    <p v-else>No scores yet. Be the first!</p>
  </div>
</template>

<script setup>
/* eslint-env vue/setup-compiler-macros */
import { toRefs } from "vue";

const props = defineProps({
  scores: {
    type: Array,
    default: () => [],
    validator: (arr) =>
      Array.isArray(arr) &&
      arr.every(
        (s) => s && typeof s.name === "string" && s.points !== undefined
      ),
  },
});

const { scores } = toRefs(props); // ✅ mantiene reactividad
</script>

<!-- Opcional: si quieres nombre de componente sin macros -->
<script>
export default { name: "HighScores" };
</script>

<style scoped>
.high-scores {
  padding: 15px;
  border-radius: 8px;
  background-color: #f9f9f9;
  min-width: 250px;
}
h3 {
  margin-top: 0;
  text-align: center;
  color: #333;
}
ol {
  list-style-type: decimal;
  padding-left: 25px;
  margin: 0;
}
li {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}
li:last-child {
  border-bottom: none;
}
span:first-child {
  font-weight: bold;
}
</style>
